import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import StatsLoader from "./statsSkeleton";

// import { getNotificationList } from "../../redux/actions/notificationList";
import { getNotificationCount } from "../../redux/actions/notificationCount";
import DasboardNotification from "./dashboardNotification";


const Stats = (props) => {
  const { loading, provider_stats, stats, notifications } = props
  const leadsCount = Number(provider_stats?.leads_unlocked_count ?? provider_stats?.project_interactions ?? 0);
  const earnedAmount = Number(provider_stats?.earned_completed_only ?? provider_stats?.earned ?? 0);
  const walletAmount = Number(provider_stats?.wallet_balance ?? 0);
  const providerRating = Number(provider_stats?.provider_rating ?? 0);
  const ratingDisplay = `${providerRating.toFixed(1)} / 5`;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getNotificationCount());
    // dispatch(getNotificationList());
  }, []);
  // notificationCount
  const notificationCount = useSelector(state => state.notificationCount.notification_count);
  const firstFiveNotifications = useSelector(state => state.firstFiveNotifications.data);
  const firstFiveNotificationsLoading = useSelector(state => state.firstFiveNotifications.loading);
  const firstFiveNotificationsError = useSelector(state => state.firstFiveNotifications.error);
  const firstTwoNotifications = firstFiveNotifications && firstFiveNotifications.length != 0 && firstFiveNotifications.slice(0, 2);

  return (
    <section className="ebw-section ebw-section--achievements">
      <div className="ebw-achievements__inwrap container px-0 px-md-3">
        <div className="ebw-achivements__wrap d-flex flex-wrap align-items-center">
          <div className={`ebw-achievements__items d-flex flex-wrap align-items-start mb-3 mb-md-0 ${firstTwoNotifications.length ? "ebw-achievements__items-withMsg" : ""}`}>
            <div className="ebw-achievements__item">
              {loading ?
                <div className="my-auto">
                  <StatsLoader
                  />
                </div>
                :
                (

                  <>
                    <div className="ebw-achievements__item-icon  mb-2">
                      <img className="img-fluid" src="./images/dashboard/bidded.svg" alt="Leads" />
                    </div>
                    <div className="mb-2 text-center text-md-left">
                      <div className="ebw-achievements__item-count"><span>{leadsCount}</span></div>
                      <div className="ebw-achievements__item-title">Leads</div>
                    </div>
                    <div className="ebw-achievements__item-para d-none d-md-block">{leadsCount === 0 ? "Projects will appear here once you unlock a lead." : "Active leads unlocked by you."}</div>
                  </>

                )
              }
            </div>

            <div className="ebw-achievements__item">
              {loading ?
                <div className="my-auto">
                  <StatsLoader
                  // width={150}
                  // height={100}
                  />
                </div> :
                (

                  <>
                    <div className="ebw-achievements__item-icon  mb-2">
                      <img className="img-fluid" src="./images/dashboard/earned.svg" alt="Earned" />
                    </div>
                    <div className="mb-2 text-center text-md-left">
                      <div className="ebw-achievements__item-count">$<span>{earnedAmount.toFixed(2)}</span></div>
                      <div className="ebw-achievements__item-title">Earned</div>
                    </div>
                    <div className="ebw-achievements__item-para d-none d-md-block">{earnedAmount === 0 ? "Start completing projects to build your earnings." : "Earnings from completed projects."}</div>
                  </>

                )
              }
            </div>

            <div className="ebw-achievements__item">
              {loading ?
                <div className="my-auto">
                  <StatsLoader
                  />
                </div> :
                (

                  <>
                    <div className="ebw-achievements__item-icon  mb-2">
                      <img className="img-fluid" src="./images/dashboard/saved.svg" alt="Wallet" />
                    </div>
                    <div className="mb-2 text-center text-md-left">
                      <div className="ebw-achievements__item-count">$<span>{walletAmount.toFixed(2)}</span></div>
                      <div className="ebw-achievements__item-title">Wallet</div>
                    </div>
                    <div className="ebw-achievements__item-para d-none d-md-block">{walletAmount === 0 ? "Add funds to your wallet to unlock more leads." : "Current available wallet balance."}</div>
                  </>

                )
              }
            </div>

            <div className="ebw-achievements__item">
              {loading ?
                <div className="my-auto">
                  <StatsLoader
                  />
                </div> :
                (

                  <>
                    <div className="ebw-achievements__item-icon  mb-2">
                      <img className="img-fluid" src="./images/dashboard/completed.svg" alt="Rating" />
                    </div>
                    <div className="mb-2 text-center text-md-left">
                      <div className="ebw-achievements__item-count"><span>{ratingDisplay}</span></div>
                      <div className="ebw-achievements__item-title">Rating</div>
                    </div>
                    <div className="ebw-achievements__item-para d-none d-md-block">{providerRating === 0 ? "Your rating will appear after customer reviews." : "Average customer rating."}</div>
                  </>

                )
              }
            </div>
          </div>
          {firstTwoNotifications.length ?
            <div className="ebw-achievements__msg-box px-3 px-md-0">
              <div className="ebw-card ebw-card__others py-3">
                <div className="ebw-achievements__notification-list">
                  {<DasboardNotification firstTwoNotifications={firstTwoNotifications} notificationLoading={firstFiveNotificationsLoading} />}
                  <div className="text-center pt-3">
                    <Link className="ebw-button__plain--blue" to="/notifications/">Show all notifications</Link>
                  </div>
                </div>
              </div>
            </div> :
            ""
          }
        </div>
      </div>
    </section>
  );
}

export default Stats;
